import React, { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ValidationRibbon from './components/ValidationRibbon';
import WhoWeAre from './components/WhoWeAre';
import Capabilities from './components/Capabilities';
import TalentModel from './components/TalentModel';
import ContactTerminal from './components/ContactTerminal';
import Footer from './components/Footer';

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => { const handleScroll = () => setScrolled(window.scrollY > 24); window.addEventListener('scroll', handleScroll, { passive: true }); return () => window.removeEventListener('scroll', handleScroll); }, []);
  const scrollToSection = (id) => { document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }); setMobileMenuOpen(false); };
  return <div className="relative min-h-screen overflow-x-hidden"><div className="pointer-events-none fixed inset-0 -z-10 bg-grid-light opacity-60" /><div className="glass-orb -left-24 top-32 h-72 w-72 bg-sky-200/55" /><div className="glass-orb right-0 top-[34rem] h-96 w-96 bg-lilac/35" /><Header scrolled={scrolled} mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} onNavClick={scrollToSection} /><main><Hero onCtaClick={() => scrollToSection('get-in-touch')} /><ValidationRibbon /><WhoWeAre /><Capabilities /><TalentModel /><ContactTerminal /></main><Footer /></div>;
}
export default App;
